import { FiMenu } from 'react-icons/fi';
import { useLocation } from 'react-router-dom';
import UserProfileMenu from './UserProfileMenu';
import { ALL_MENU_ENTRIES } from '../../config/menuCatalog';

const resolveTitle = (pathname: string): string => {
  // Find the menu entry whose path is a prefix of the current pathname
  const match = ALL_MENU_ENTRIES.find((entry) =>
    pathname.startsWith(entry.path)
  );
  return match ? match.label : 'Dashboard';
};

type TopHeaderProps = {
  onToggleSidebar: () => void;
  isSidebarCollapsed: boolean;
};

function TopHeader({ onToggleSidebar, isSidebarCollapsed }: TopHeaderProps) {
  const location = useLocation();
  const title = resolveTitle(location.pathname);

  return (
    <header className="h-14 flex items-center justify-between border-b border-slate-200/90 bg-white/95 px-4 backdrop-blur lg:px-6">
      <div className="flex items-center gap-3">
        <button
          type="button"
          className="inline-flex h-8 w-8 items-center justify-center rounded-md border border-slate-200 text-slate-600 transition-colors hover:bg-slate-100"
          onClick={onToggleSidebar}
          title={isSidebarCollapsed ? 'Mở rộng menu' : 'Thu gọn menu'}
        >
          <FiMenu className="text-base" />
        </button>
        <h1 className="text-base font-semibold text-slate-800 tracking-tight">{title}</h1>
      </div>
      <UserProfileMenu />
    </header>
  );
}

export default TopHeader;
